'use client';

import { ErrorScreen } from '@/app/_global/_components/ErrorScreen/ErrorScreen';
import { useExitToOrigin } from '@/app/_global/_hooks/useExitToOrigin';

export default function NotFound() {
  const { exitToOrigin } = useExitToOrigin();

  return (
    <ErrorScreen
      title="페이지를 찾을 수 없어요"
      description={
        <>
          요청하신 페이지가 존재하지 않거나
          <br />
          이동·삭제됐을 수 있어요.
        </>
      }
      primaryAction={{ label: '메인으로 가기', onClick: exitToOrigin }}
    />
  );
}
